import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';

export const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen py-20 px-4 sm:px-6 lg:px-8 bg-[#0B1120] text-white">
      <Helmet>
        <title>Privacy Policy | Nitro Logs</title>
        <meta name="robots" content="index, follow" />
      </Helmet>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-5xl mx-auto"
      >
        <div className="mb-10 text-center">
          <p className="text-sm uppercase tracking-widest text-blue-400">Legal</p>
          <h1 className="text-4xl lg:text-5xl font-bold mt-4">Privacy Policy</h1>
          <p className="mt-4 text-gray-400 max-w-3xl mx-auto">
            Learn how Nitro Logs collects, uses, protects, and shares your information when
            you use our services.
          </p>
        </div>

        <div className="space-y-10 text-gray-300">
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Information We Collect</h2>
            <p className="leading-relaxed">
              We collect information that helps us deliver and improve our services. This includes account details,
              payment information, and usage data. We also collect data you choose to provide when contacting support.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">How We Use Your Data</h2>
            <ul className="list-disc list-inside space-y-2 leading-relaxed">
              <li>To process payments, fulfill orders, and manage your account.</li>
              <li>To communicate important updates about your purchases and account.</li>
              <li>To improve our platform, customer support, and product offerings.</li>
              <li>To help protect against fraud and unauthorized transactions.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Data Sharing</h2>
            <p className="leading-relaxed">
              We do not sell your personal information. We may share data with payment processors, service providers,
              and legal authorities when required by law.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Your Rights</h2>
            <p className="leading-relaxed">
              You can access, update, or delete your account information by contacting support or using the
              account settings available in the platform.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Contact Us</h2>
            <p className="leading-relaxed">
              If you have questions about this Privacy Policy, please contact us at nitrologs9@gmail.com.
            </p>
          </section>
        </div>
      </motion.div>
    </div>
  );
};
